import { ButtonColors } from '../../enums/components/Button/ButtonColor.enum';

export type LinkActionButton = {
  text: string;
  style: ButtonColors;
  buttonType: ButtonType.Url;
  url: string;
};

export type ModalActionButton = {
  text: string;
  style: ButtonColors;
  buttonType: ButtonType.Modal;
  modalText: string;
};

export type ActionButton = LinkActionButton | ModalActionButton;

export enum ButtonType {
  Url = 'url',
  Modal = 'modal',
}

export const BUTTON_TYPES = [
  { label: 'URL', value: ButtonType.Url },
  { label: 'Modal', value: ButtonType.Modal },
];
